var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDustGood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M459.281 112C267.487 112 112 273.177 112 472L112 552C112 750.823 267.487 912 459.281 912L564.719 912C756.513 912 912 750.823 912 552L912 472C912 273.177 756.513 112 564.719 112L459.281 112ZM463.219 142L560.781 142C738.191 142 882 291.089 882 475L882 549C882 732.911 738.191 882 560.781 882L463.219 882C285.809 882 142 732.911 142 549L142 475C142 291.089 285.809 142 463.219 142Z",
    fill: "#1399ff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.774 333.146C379.595 336.615 365.906 357.324 365.906 357.324C365.906 357.324 348.322 339.233 319.922 340.5C300.878 341.351 284.39 351.804 274.382 367.187C239.56 420.708 320.922 473.1 340.256 487.375C351.823 495.915 366.055 506.017 374.545 511.999C378.79 514.994 384.621 514.506 388.199 510.855C395.356 503.564 407.34 491.267 417.013 480.949C433.183 463.701 502.767 398.673 457.858 351.827C444.964 338.361 426.67 330.82 407.774 333.146Z",
    fill: "#1399ff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.226 333.146C644.405 336.615 658.094 357.324 658.094 357.324C658.094 357.324 675.678 339.233 704.078 340.5C723.122 341.351 739.61 351.804 749.618 367.187C784.44 420.708 703.078 473.1 683.744 487.375C672.177 495.915 657.945 506.017 649.455 511.999C645.21 514.994 639.379 514.506 635.801 510.855C628.644 503.564 616.66 491.267 606.987 480.949C590.817 463.701 521.233 398.673 566.142 351.827C579.036 338.361 597.33 330.82 616.226 333.146Z",
    fill: "#1399ff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.922 613.05C404.605 751.141 624.39 756.761 649.046 613.939",
    fill: "none",
    opacity: 1,
    stroke: "#1399ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 45
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustGood);
export default __webpack_public_path__ + "static/media/DustGood.e80759f8b775f2225549f81b1d163c79.svg";
export { ForwardRef as ReactComponent };